var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuggage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#666",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.358 20.238H6.915a1.422 1.422 0 01-1.421-1.422V6.663c0-.785.636-1.421 1.421-1.421h9.443c.785 0 1.42.636 1.42 1.421v12.153c0 .785-.635 1.422-1.42 1.422z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.022 5.242H9.186V4.036c0-.788.64-1.428 1.428-1.428h1.979c.789 0 1.429.64 1.429 1.428v1.206zM10.245 20.683a.974.974 0 01-1.947 0M15.442 20.683a.974.974 0 01-1.947 0"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 2,
    d: "M13.897 8.522v8.5"
  })))));
}
export default SvgLuggage;